import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import COLORS from "../../../constants/colors";
import FONTS from "../../../constants/fonts";
import SIZES from "../../../constants/sizes";

const heightMap = {
  [SIZES.MEDIUM]: 28,
  [SIZES.LARGE]: 38
};

export const getHeight = size => heightMap[size];

const getSizingDefinitions = size => {
  if (size === SIZES.LARGE) {
    return css`
      font-size: 16px;
      height: 38px;
    `;
  } else {
    // medium (default)
    return css`
      font-size: 14px;
      height: 28px;
    `;
  }
};

const StyledButton = styled.button`
  ${props => getSizingDefinitions(props.size)};
  background-color: transparent;
  padding: 0;
  border: none;
  border-radius: 2px;
  color: ${COLORS.TEXT_COLORS.LINK};
  cursor: pointer;
  font-family: ${FONTS.FONT_FAMILY.DEFAULT};
  line-height: 1;
  box-sizing: content-box;
  text-align: left;
  padding: 4px 0;

  &:hover,
  &:focus {
    color: ${COLORS.ACTION_COLORS.BLUE_MAIN_HOVER};
  }

  &:active {
    color: ${COLORS.ACTION_COLORS.BLUE_MAIN_ACTIVE};
  }
`;

const LinkButton = props => <StyledButton type="button" {...props} />;

LinkButton.defaultProps = {
  size: SIZES.MEDIUM
};

LinkButton.propTypes = {
  /** onClick handler function */
  onClick: PropTypes.func.isRequired,
  /** link button text size */
  size: PropTypes.oneOf([SIZES.MEDIUM, SIZES.LARGE])
};

export default LinkButton;
